module.exports = __webpack_public_path__ + "static/img/omc.8f6ffc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/omc.png
// module id = QIpn
// module chunks = 1